import { Fragment } from 'react'
import { cn } from '#/lib/utils'

export function Stepper({ steps, current, className }: { steps: string[]; current: number; className?: string }) {
  return (
    <ol className={cn('flex items-center gap-2 text-xs', className)} aria-label="steps">
      {steps.map((label, i) => {
        const active = i === current
        const done = i < current
        return (
          <Fragment key={label}>
            <li className={cn('flex items-center gap-1.5', active ? 'font-medium text-foreground' : 'text-muted-foreground')}>
              <span
                className={cn(
                  'size-2 rounded-full',
                  active || done ? 'bg-primary' : 'bg-muted-foreground/40',
                )}
              />
              {label}
            </li>
            {i < steps.length - 1 ? <span className="h-px w-8 bg-border" /> : null}
          </Fragment>
        )
      })}
    </ol>
  )
}
